var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFoldericon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.622 4.243c0-1.05-.852-1.903-1.903-1.903h-8.561c.038 0 .026-.015-.058-.116l-.075-.092-.182-.234-.116-.149C10.046.89 9.367.437 8.302.437H2.594C1.543.438.69 1.29.69 2.34v13.32c0 1.05.852 1.902 1.903 1.902h17.125c1.05 0 1.902-.851 1.902-1.902V4.243zm-1.903 0V15.66H2.594V2.34h5.708c.366 0 .578.142.934.591l.083.107c.077.099.182.235.225.288.479.594.924.913 1.607.917h8.568z",
    fill: "#7C8193"
  })));
}
export default __webpack_public_path__ + "media/images/Foldericon-f0f22b41.svg";
export { SvgFoldericon as ReactComponent };